/* Open links that leave mossify.ca in a new tab. Checkout, Shop Pay, mailto/tel and same-site links are untouched. */
(function () {
  var SAME = [location.hostname.replace(/^www\./, ''), 'mossify.ca', 'myshopify.com', 'shopify.com', 'shop.app'];
  function internal(host) {
    host = host.replace(/^www\./, '');
    return SAME.some(function (d) { return host === d || host.endsWith('.' + d); });
  }
  function external(a) {
    if (!a || !a.href || a.hasAttribute('download')) return false;
    if (a.protocol !== 'http:' && a.protocol !== 'https:') return false;
    return !internal(a.hostname);
  }
  function mark(a) {
    if (!external(a)) return;
    a.target = '_blank';
    var rel = (a.rel || '').split(/\s+/);
    if (rel.indexOf('noopener') < 0) rel.push('noopener');
    a.rel = rel.join(' ').trim();
  }
  function scan(root) { (root.querySelectorAll ? root.querySelectorAll('a[href]') : []).forEach(mark); }
  document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href]'); if (a) mark(a); }, true);
  scan(document);
  new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.matches('a[href]')) mark(n); scan(n); } }); }); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
